import { useState, useEffect } from 'react';
import { Grid, InputLabel, FormControlLabel, FormLabel, Radio, RadioGroup, Box } from '@mui/material';
import Controls from '../controls/Controls';
import { useForm, Form } from "../useForm"

const initialFValues = {
  index: -1,
  displayName: '',
}

export default function FormatControl(props) {
  const { addOrEdit, recordForEdit } = props
  const [applicableTo, setApplicableTo] = useState(recordForEdit?.applicableTo || "all");
  const [applyTo, setApplyTo] = useState(recordForEdit?.applyTo || "selectedSheet");
  const [displayType, setDisplayType] = useState(recordForEdit?.displayType ?? "DROPDOWN");

  const validate = (fieldValues = values) => {
    let temp = { ...errors }

    if ('displayNameOnSheet' in fieldValues) {
      temp.displayNameOnSheet = fieldValues.displayNameOnSheet ? "" : "Display Name is required."
    }

    setErrors({...temp})

    if (fieldValues === values)
      return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleInputChangeApplicableTo = (event) => {
    setApplicableTo(event.target.value);
  }

  const handleInputChangeApplyTo = (event) => {
    setApplyTo(event.target.value);
  }

  const onChangeDisplayType = (event) => {
    setDisplayType(event.target.value);
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) {
      values.applicableTo = applicableTo;
      values.applyTo = applyTo;
      values.displayType = displayType;
      addOrEdit(values, resetForm);
    }
  }

  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
  }, [recordForEdit, setValues])


  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <InputLabel className="text-small label">Display Name On Sheet</InputLabel>
          <Controls.Input
            className="report_form_ui_input m-0 width-100"
            name="displayNameOnSheet"
            value={values.displayNameOnSheet}
            onChange={handleInputChange}
            error={errors.displayNameOnSheet}
          />
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }} >
          <FormLabel className="text-small label" component="legend">Applicable to</FormLabel>
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={applicableTo}
            onChange={handleInputChangeApplicableTo}
            row
          >
            <FormControlLabel className="text-small" value="dataset" control={<Radio className="form_icon" size='small' />} label="Visuals of this dataset" />
            <FormControlLabel className="text-small" value="all" control={<Radio className="form_icon" size='small' />} label="All Visuals of sheet" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }} >
          <FormLabel className="text-small label" component="legend">Apply to</FormLabel>
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={applyTo}
            onChange={handleInputChangeApplyTo}
            row
          >
            <FormControlLabel className="text-small" value="allSheets" control={<Radio className="form_icon" size='small' />} label="All Sheets" />
            <FormControlLabel className="text-small" value="selectedSheet" control={<Radio className="form_icon" size='small' />} label="Selected Sheet" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }} >
          <FormLabel className="text-small label" component="legend">Display Type</FormLabel>
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={displayType}
            onChange={onChangeDisplayType}
            row>
            <FormControlLabel className="text-small" value="SLIDER" control={<Radio className="form_icon" size='small' />} label="Slider" />
            <FormControlLabel className="text-small" value="DROPDOWN" control={<Radio className="form_icon" size='small' />} label="Dropdown" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12} >
          <Box sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
            <Controls.Button
              className="report_form_ui_btn cancel mr-2"
              color="secondary"
              text="Reset"
              onClick={resetForm}
            />
            <Controls.Button className="report_form_ui_btn submit " type="submit" text="submit" />
          </Box>
        </Grid>
      </Grid>
    </Form>
  )
}